import axios from 'axios';
import { setup } from 'axios-cache-adapter'
import TokenService from "./token.service";
const swal =require('sweetalert2');
import router from '../router/index.js';

import { store } from '../_store';

axios.defaults.baseURL = localStorage.apiurl ? localStorage.apiurl : process.env.VUE_APP_API_ENDPOINT

// const frenapi = axios.create();
// Create cached axios instance with custom invalidate method
const frenapi = setup({
  cache: {
    maxAge: 5 * 60 * 1000,
    readHeaders: true,
    exclude: { query: false },
    // Invalidate only when a specific option is passed through config
    invalidate: async (config, request) => {
      if (request.clearCache) {
        await config.store.removeItem(config.uuid)
      }
    }
  }
})



frenapi.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;
      if (originalConfig.url !== "/users/token" && err.response) {
        // Access Token was expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          try {
            const rs = await frenapi.post("/users/refreshtoken", {
              refreshToken: TokenService.getLocalRefreshToken(),
            });
            const { access_token, refresh_token } = rs.data;
            store.dispatch('authentication/refreshToken', access_token);
            TokenService.updateLocalRefreshToken(refresh_token);
            TokenService.updateLocalAccessToken(access_token);
            return frenapi(originalConfig);
          } catch (_error) {
            store.dispatch('authentication/logout');
            swal.fire({
              icon: 'warning',
              title: 'Ουπς...',
              text: 'Η συνεδρεία έχει λήξει!',
             // footer: '<a href="">Why do I have this issue?</a>'
             confirmButtonText: "Σύνδεση",
            }).then(()=> {
                // window.location = '/login';
                router.push({
                    path: '/login',
                    query: { redirect: window.location.pathname }
                      }
                                

                );
            });
            // return Promise.reject(_error);
        }
      }
      return Promise.reject(err);
    }
 }
);


// using Interceptors
frenapi.interceptors.request.use(config => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
        config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
    },
    (error) => {
      return Promise.reject(error);
    });


export default frenapi

